//include 9
jQuery(function(){

    $(".dce-themen_slider.paginationUsed").each((index, element) => {
        var $element = $(element);
        var loading = false;
        // On before slide change
        $element.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            var id = $element.attr("id");            
            var length = slick.$slides.length;
            if(nextSlide > length - 6){
                if(loading == true){
                    return;
                }
                var page = $element.data("page") || 2;
                loading = true;
                var getParams = $element.data("get-params") || {};
                getParams.page = page;
                $element.data("get-params",getParams);
                window.pixelpoint.ppComponents.module.reload($element,true,function(data){
                    var parsedContent = $('<output>').append($.parseHTML(data));
                    var newSlides = parsedContent.find(`#${id} div.item`);
                    if(newSlides.length > 0){
                        newSlides.each(function(){
                            slick.addSlide(this.outerHTML);
                        });
                        page++;
                        $element.data("page",page);
                    }
                    loading = false;
                });
            }
        });
    })
});